import React from "react";
import {TableReport} from "./table";

export class OrgManagers extends React.Component<any, any> {
    constructor(props:any) {
        super(props);
    }

    render() {
        const table_columns = ["Email", "First Name", "Last Name"];
        const table_rows = [
            {
                "email": "Some Email",
                "first_name": "First Name",
                "last_name": "Last Name"
            },
            {
                "email": "Some Email",
                "first_name": "First Name",
                "last_name": "Last Name"
            },
            {
                "email": "Some Email",
                "first_name": "First Name",
                "last_name": "Last Name"
            }
        ];
        return (
            <div>
                <TableReport table_columns={table_columns} table_rows={table_rows}/>
            </div>
        )
    }
}